import $ from 'sbf-design-system/js/jquery';
import banner from 'sbf-design-system-component/banners/banner';

const btClient = window.braintree && window.braintree.client;
const paypalCheckout = window.braintree && window.braintree.paypalCheckout;
const { paypal } = window;

const $form = $('#donation-form');

export const braintreeClient = (authorization) => {
  return new Promise((resolve, reject) => {
    btClient.create({
      authorization
    }, (err, client) => {
      if (err != null) { reject(err); } else { resolve(client); }
    });
  });
};

export const braintreeCCRequest = (client, nonceData) => {
  return new Promise((resolve, reject) => {
    client.request({
      endpoint: 'payment_methods/credit_cards',
      method: 'post',
      data: {
        creditCard: nonceData
      }
    }, (err, response) => {
      if (err != null) { reject(err); } else { resolve(response.creditCards[0].nonce); }
    });
  });
};

export const braintreePaypalCheckout = ({ client, flow, buttonSelector, amountCB, cb }) => {
  return new Promise((resolve, reject) => {
    paypalCheckout
      .create({
        client
      })
      .then(instance => {
        paypal.Button.render({
          env: window.gon.paypal_env,
          style: {
            tagline: false,
            size: 'responsive',
            height: 55,
            color: 'gold',
            shape: 'rect',
            label: 'paypal'
          },
          funding: {
            disallowed: [paypal.FUNDING.CREDIT]
          },
          validate: (actions) => {
            toggleButton(actions);
            $form.off('change.btform', '.donor-entity-type-attribute-input, .inline-input').on('change.btform', '.donor-entity-type-attribute-input, .inline-input', () => toggleButton(actions));
          },
          onClick: () => {
            toggleValidationMessage();
            setRequiredInputFields();
          },
          payment: () => {
            let paymentOptions = {
              flow: flow(),
              currency: 'USD',
              amount: amountCB(),
              enableBillingAddress: true
            };
            if (flow === 'checkout') {
              paymentOptions = Object.assign({}, paymentOptions, {
                intent: 'sale'
              });
            } else {
              paymentOptions = Object.assign({}, paymentOptions, {
                billingAgreementDescription: `Give $${amountCB()} every month to support lifesaving childhood cancer research.`
              });
            }

            if (isValid()) { // if fields pass validation, open paypal
              $('#donate-main, .section-donation-review-submit').attr('data-payment', 'paypal');
              return instance.createPayment(paymentOptions);
            }
          },
          onAuthorize: (data, actions) => {
            return instance.tokenizePayment(data).then(payload => {
              cb(payload);
            });
          },
          onCancel: data => {
            $('#donate-main, .section-donation-review-submit').attr('data-payment', 'cc');
          },
          onError: err => {
            console.error('checkout.js error', err);
            banner.showError('Invalid information. Please verify your information is correct and then try again.', false, 4000);
          }
        },
        buttonSelector
        )
          .then(() => {
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      })
      .catch(e => {
        reject(e);
      });
  });
};

// Validate fields to disable/enable paypal window
const isValid = () => {
  let returnValue = true;

  $form.find('[required]').not('.cc-fields, .required-field').each((_i, el) => {
    if (!validateField(el)) {
      returnValue = false;
    }
  });

  if (returnValue) {
    const $amountInput = $('#donation_amount');
    const amount = $amountInput.val().replace(/,/g, '');
    $amountInput.val(amount);

    if (amount <= 0) {
      returnValue = false;
    }
  }

  return returnValue;
};

const setRequiredInputFields = () => {
  $('#donation_donor_attributes_first_name').prop('required', false).change();
  $('#donation_donor_attributes_last_name').prop('required', false).change();
  $('#donation_donor_attributes_phone').prop('required', false).change();
  $('#donation_donor_attributes_email').prop('required', false).change();
  $('#donation_donor_attributes_address_attributes_zip').prop('required', false).change();
  $('#donation_donor_attributes_organization_name').prop('required', false).change();
};

const validateField = (el) => {
  const valid = true;

  if (!valid || !$(el).parsley().isValid(true)) {
    return false;
  }
  return true;
};

const toggleButton = (actions) => {
  if (isValid()) {
    actions.enable();
  } else {
    actions.disable();
  }
};

const toggleValidationMessage = () => {
  if (!isValid()) { displayErrors(); }
};

// Display form errors on paypal button click
const displayErrors = () => {
  let returnValue = true;

  // reset valid before checking
  $form.find('[required]').closest('.inline-input').removeClass('invalid');
  $form.find('[required]').not('.cc-fields').each((_i, el) => {
    if (!validateField(el)) {
      $(el).closest('.inline-input').addClass('invalid');

      // special handling for state/province/region
      if (el.name === 'state') {
        $('#states_wrapper').addClass('invalid');
      }

      $form.addClass('form__error');
      returnValue = false;
    }
  });

  if (!returnValue) {
    banner.showError('Please provide the required information.', false, 4000);
    return false;
  }
};
